import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TypeTabs = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TypeTab = styled.button`
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray3};
  background-color: ${({ theme, $active }) =>
    $active
      ? theme.colors.feedbackState.info.default
      : theme.colors.neutral.white};
  color: ${({ theme, $active }) =>
    $active ? theme.colors.neutral.white : theme.colors.neutral.black};
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
`;

export const RecipientsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const RecipientRow = styled.li`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray3};
  border-radius: 12px;
`;

export const RecipientInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  strong {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.neutral.black};
  }

  span {
    font-size: 13px;
    color: ${({ theme }) => theme.colors.neutral.gray6};
  }
`;

export const Checkbox = styled.input.attrs({ type: "checkbox" })`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: ${({ theme }) => theme.colors.feedbackState.info.default};
`;

export const AlertRow = styled.div`
  margin-top: 6px;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const EmptyMessage = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.neutral.gray6};
`;
